<div class="mr-5 p-5 bg-white w-full">
    <form [formGroup]="formEntrada">
        <div class="flex p-5 pt-0 pb-0 flex-col">
            <label style="padding-left:5px">Tipo de Correo</label>
            <mat-radio-group aria-label="Tipo de Correo:" formControlName="tipoCorreo">
                <mat-radio-button color="primary" value="1">Entrada</mat-radio-button>
                <mat-radio-button color="primary" value="2">Salida</mat-radio-button>
            </mat-radio-group>
        </div>        
        <div class="flex p-5 pb-0 flex-row">
            <mat-form-field class="mr-5" [class.campo-encontrado]="campos.includes('fechaInicio')">
                <mat-label>Fecha Inicio</mat-label>
                <input matInput [matDatepicker]="picker1" [max]="today" formControlName="fechaInicio">
                <!-- <mat-hint>DD/MM/YYYY</mat-hint> -->
                <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                @if(formEntrada.controls["fechaInicio"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>       
                } 
            </mat-form-field>
            <mat-form-field class="mr-5" [class.campo-encontrado]="campos.includes('fechaFin')">
                <mat-label>Fecha Fin</mat-label>
                <input matInput [matDatepicker]="picker2" [min]="formEntrada.value.fechaInicio"  formControlName="fechaFin">
                <!-- <mat-hint>DD/MM/YYYY</mat-hint> -->
                <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
                @if(formEntrada.controls["fechaFin"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>       
                }
            </mat-form-field>

            <app-treemap class="flex flex-1 mr-5"></app-treemap>
        </div>
        <div class="flex p-5 pb-0">
            <mat-form-field class="!w-full mr-5" [class.campo-encontrado]="campos.includes('asunto')">
                <mat-label>Asunto</mat-label>
                <input type="text" matInput formControlName="asunto" maxlength="300" #asunto>
                <mat-hint align="end">{{asunto.value.length}} / 300</mat-hint>
                @if(formEntrada.controls["asunto"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
            </mat-form-field>
        </div>
        <div class="flex flex-row p-5 pb-0 mr-5 items-baseline">
            <mat-form-field class="flex flex-auto mr-5" [class.campo-encontrado]="campos.includes('remitente')">
                <mat-label>Remitente</mat-label>
                <input #inputRemitente
                    type="text"
                    matInput
                    formControlName="remitente"
                    [matAutocomplete]="auto"
                    (input)="selectedFilter()"
                    (focus)="selectedFilter()">
                <mat-autocomplete requireSelection #auto="matAutocomplete" [displayWith]="selectedDisplayRemitente.bind(this)" (optionSelected)="selectedOption('remitente', $event)">
                    @for (item of filterRemitente; track item) {
                        <mat-option [value]="item.id">{{item.nombre}} {{item.apellido}} ({{item.mail}})</mat-option>
                    }
                </mat-autocomplete>
                @if(formEntrada.controls["remitente"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>       
                }
            </mat-form-field>
            <button mat-icon-button color="primary" type="button" (click)="addRemitente()" [disabled]="formEntrada.controls['remitente'].disabled || formEntrada.controls['tipoCorreo'].value == 2" class="flex p-1">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        <div class="mr-5">
            <app-add-remitente [remitentes]="catRemitente" (remitentesNuevo)="newRemitente($event)"></app-add-remitente>
        </div>
        <div class="flex p-5 pb-0 items-start">
            <mat-chip-set role="list" class="w-1/2 mr-5" [disabled]="deshabilitado">
                @for (item of lista_enviado_a; track item) {
                <mat-chip (removed)="removeList('enviado_a', item.id)">
                    {{item.nombre}} {{item.apellido}}
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip>
                }
                @for (item of lista_delegado; track item) {
                <mat-chip (removed)="removeList('delegado', item.id)">
                    {{item.nombre}} {{item.apellido}}
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip>
                }
            </mat-chip-set>
            <mat-chip-set class="w-1/2 mr-5" [disabled]="deshabilitado">
                @for (item of lista_copia; track item) {
                  <mat-chip (removed)="removeList('copia', item.id)">
                    {{item.nombre}} {{item.apellido}}
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip>
                }
            </mat-chip-set>
        </div>
        <div class="flex p-5 pt-0 pb-0">
            <mat-form-field class="w-1/2 mr-5" [class.campo-encontrado]="campos.includes('delegadoA')">
                <mat-label>Enviado a<span class="obligatorio"></span></mat-label>
                <input type="text"
                    matInput
                    formControlName="remitente_enviado"
                    [matAutocomplete]="remitente_enviado">
                <mat-autocomplete #remitente_enviado="matAutocomplete" [displayWith]="selectedDisplay" (optionSelected)="selectedOption((formEntrada.controls['remitente'].value == '-Kd1EX0gNjABLH0Yj0fN')?'enviado_a':'delegado', $event)">
                    @for (item of filterEnviadoA | async; track item) {
                        <mat-option [value]="item.id">{{item.nombre}} {{item.apellido}} ({{item.mail}})</mat-option>
                    }
                </mat-autocomplete>
                @if(formEntrada.controls["remitente_enviado"].hasError('error_enviado_a')) {
                    <mat-error>Campo obligatorio.</mat-error>       
                }
            </mat-form-field>
            <!-- <mat-form-field class="w-1/2 mr-5">
                <mat-label>Delegado</mat-label>
                <input type="text"
                    matInput
                    formControlName="delegado"
                    [matAutocomplete]="delegado">
                <mat-autocomplete #delegado="matAutocomplete" [displayWith]="selectedDisplay" (optionSelected)="selectedOption('delegado', $event)">
                    @for (item of filterDelegado | async; track item) {
                        <mat-option [value]="item.id">{{item.nombre}} {{item.apellido}} ({{item.mail}})</mat-option>
                    }
                </mat-autocomplete>
                @if(formEntrada.controls["delegado"].hasError('error_delegado')) {
                    <mat-error>Campo obligatorio.</mat-error>       
                }
            </mat-form-field> -->
            <mat-form-field class="w-1/2 mr-5">
                <mat-label>Con Copia a</mat-label>
                <input #input
                       type="text"
                       matInput
                       formControlName="copia"
                       [matAutocomplete]="copia">
                <mat-autocomplete #copia="matAutocomplete" [displayWith]="selectedDisplay" (optionSelected)="selectedOption('copia', $event)">
                    @for (item of filterConCopiaA | async; track item) {
                        <mat-option [value]="item.id">{{item.nombre}} {{item.apellido}} ({{item.mail}})</mat-option>
                    }
                </mat-autocomplete>
                @if(formEntrada.controls["copia"].hasError('error_copia')) {
                    <mat-error>Campo obligatorio.</mat-error>       
                }
            </mat-form-field>
        </div>
        <div class="flex p-5 pb-0">
            <mat-form-field class="w-1/4 mr-5" [class.campo-encontrado]="campos.includes('tema')">
                <mat-label>Tema</mat-label>
                <mat-select formControlName="tema">
                    @for (item of catTema; track item) {
                        @if(oUsuario.escritura.includes(item.id)) {
                            <mat-option [value]="item.id">{{item.descripcion}}</mat-option>
                        }
                    }
                </mat-select>
                @if(formEntrada.controls["tema"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="w-1/4 mr-5" [class.campo-encontrado]="campos.includes('tipo')">
                <mat-label>Tipo</mat-label>
                <mat-select formControlName="tipo">
                    @for (item of catTipo; track item.id) {
                        @if(item.activo) {
                            <mat-option [value]="item.id">{{item.descripcion}}</mat-option>
                        }
                    }
                </mat-select>
                @if(formEntrada.controls["tipo"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
            </mat-form-field>
            <mat-form-field class="w-1/4 mr-5" [class.campo-encontrado]="campos.includes('modoEntrada')">
                <mat-label>Modo de Entrada</mat-label>
                <mat-select formControlName="modo_entrada">
                    @for (item of catModoEntrada; track item.id) {
                        @if(item.activo) {
                            <mat-option [value]="item.id">{{item.descripcion}}</mat-option>
                        }
                    }
                </mat-select>
                @if(formEntrada.controls["modo_entrada"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
                @if(oEntrada.folio !== '') {
                    <mat-hint align="end" id="folio" class="idSobre">#ID {{oEntrada.folio}}</mat-hint>
                }
                
            </mat-form-field>
            <mat-form-field class="w-1/4 mr-5" [class.campo-encontrado]="campos.includes('prioridad')">
                <mat-label>Prioridad</mat-label>
                <mat-select formControlName="prioridad">
                    @for (item of catPrioridad; track item.id) {
                        @if(item.activo) {
                            <mat-option [value]="item.id">{{item.descripcion}}</mat-option>
                        }
                    }
                </mat-select>
                @if(formEntrada.controls["prioridad"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
            </mat-form-field>                                    
        </div>
        <div class="flex p-5 pb-0">
            <mat-form-field class="w-1/2 pr-5" [class.campo-encontrado]="campos.includes('empresa')">
                <mat-label>Empresa</mat-label>
                <mat-select formControlName="empresa">
                    @for (item of catEmpresa; track item.id) {
                        @if(item.activo) {
                            <mat-option [value]="item.id">{{ item.descripcion}}</mat-option>
                        }
                    }
                    <mat-option value="otro">Otro</mat-option>
                </mat-select>
                @if(formEntrada.controls["empresa"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
            </mat-form-field>
            @if(formEntrada.controls["empresa"].value == 'otro'){
                <mat-form-field class="w-1/2 pr-5" [class.campo-encontrado]="campos.includes('empresa')">
                    <mat-label>Ingresa otra empresa</mat-label>
                    <input type="text" matInput formControlName="empresa_descripcion" maxlength="100" #empresa_descripcion>
                    <mat-hint align="end">{{empresa_descripcion.value.length}} / 100</mat-hint>
                    @if(formEntrada.controls["empresa_descripcion"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
            }
        </div>

        
        <div class="flex p-5 pb-0 flex-col" [class.campo-encontrado]="campos.includes('descripcion')" [class.m-5]="campos.includes('descripcion')">
            <label class="label-descripcion">Descripción<span class="obligatorio"></span></label>
            @if(deshabilitado) {
                <div class="mt-2 NgxEditor__Content" [innerHTML]="safeHtml"></div>
            } @else {
                <div class="NgxEditor__Wrapper w-full min-h-72 mr-5" 
                    [ngClass]="{'ngx-editor-error-border': (
                        formEntrada.controls['descripcion'].value.length > 100000 || 
                        (formEntrada.controls['descripcion'].touched && formEntrada.controls['descripcion'].hasError('required'))
                    )}">
                    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" [disabled]="deshabilitado">
                    </ngx-editor-menu>
                    <ngx-editor [editor]="editor" formControlName="descripcion" [placeholder]="''" [class.campo-encontrado]="campos.includes('descripcion')" height="100px" minHeight="50px" maxlength="100000"></ngx-editor>
                </div>
                <div class="flex flex-row">
                    <div class="w-1/2">
                        @if(formEntrada.controls["descripcion"].touched && formEntrada.controls["descripcion"].hasError('required')) {
                            <mat-error>Campo obligatorio.</mat-error>
                        }
                    </div>
                    <div class="w-1/2 text-right">
                        <mat-hint [ngClass]="{'ngx-editor-error-text': (formEntrada.controls['descripcion'].value.length > 100000)}">
                            {{formEntrada.controls["descripcion"].value.length}} / 100000
                        </mat-hint>
                    </div>
                </div>
            }
        </div>
    </form>
</div>